import { Navbar } from '@/components/layouts/Navbar/Navbar';
import { PropsWithChildren } from 'react';

export function InvitationPageShell({ children }: PropsWithChildren) {
  return (
    <>
      <Navbar invitationsAmount={0} shouldShowSubscriptionsLink={false} />
      <section
        className="flex flex-1 flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("/background.svg")' }}
      >
        <div className="w-full max-w-md rounded-lg px-6 py-5">{children}</div>
      </section>
    </>
  );
}
